/* eslint-disable max-len */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable no-unused-vars */
import timelineCsv from '../data/rec-timeline.csv';

//refresh on resize
// TODO: what?! whose idea was this
$(window).on('resize', function() { location.reload(); });

// Desktop Setup
const width = window.innerWidth - 200;
const height = 300;
const svg = d3.select('#timeline-web')
  .append('svg')
  .attr('width', width)
  .attr('height', height)
  .attr('id', 'r-timeline-web');

// Mobile Setup
const mobileWidth = window.innerWidth;
const mobileHeight = 550;

const mobileSvg = d3.select('#timeline-mobile')
  .append('svg')
  .attr('width', mobileWidth)
  .attr('height', mobileHeight)
  .attr('id', 'r-timeline-mobile');

// Useful Functions
const parseTime = d3.timeParse('%m/%d/%Y %I:%M:%S%p');
const formatTime = d3.timeFormat('%b %d');

function isRange(start, end) {
  const s = parseTime(start);
  const e = parseTime(end);
  if (s.getDate() != e.getDate()) {
    return true;
  } else {
    return false;
  }
}

function getDateRange(start, end) {
  // Longer time interval
  const s = parseTime(start);
  const e = parseTime(end);
  if (s.getDate() != e.getDate()) {
    return `${d3.timeFormat('%b %d')(s)  }-${  d3.timeFormat('%b %d')(e)}`;
  } else {
    return `${d3.timeFormat('%b %d')(s)  } ${  d3.timeFormat('%I:%M')(s)  }-${  d3.timeFormat('%I:%M %p')(e)}`;
  }
}

const timelineData = [];

d3.csv(timelineCsv, function (timelineData) {
  const timeExtent = d3.extent(timelineData, function (d) {
    return parseTime(d.start);
  });

  const timeScale = d3.scaleLog()
    .domain(timeExtent)
    .range([0, width - 100]);

  const mobileTimeScale = d3.scaleLog()
    .domain(timeExtent)
    .range([0, 470]);

  // Init Lines
  svg.append('line')
    .attr('x1', 0)
    .attr('x2', width)
    .attr('y1', 100)
    .attr('y2', 100)
    .style('stroke', '#ddd')
    .style('stroke-width', '3');

  mobileSvg.append('line')
    .attr('x1', mobileWidth / 2)
    .attr('x2', mobileWidth / 2)
    .attr('y1', 0)
    .attr('y2', mobileHeight)
    .style('stroke', '#ddd')
    .style('stroke-width', '3');

  for (let j = 0; j < timelineData.length; j++) {
    const e = timelineData[j];
    if (e.start != '') {
      if (j % 2 == 0) {
        // Desktop Start -- Even
        if (!isRange(e.start, e.end)) {
          svg.append('circle')
            .attr('cx', timeScale(parseTime(e.start)) + 40)
            .attr('cy', 100)
            .attr('r', 8)
            .style('fill', '#fff')
            .style('stroke', '#E22828')
            .style('stroke-width', '3');
        } else {
          svg.append('rect')
            .attr('x', timeScale(parseTime(e.start)) + 30)
            .attr('y', 100 - 3)
            .attr('width', (timeScale(parseTime(e.end)) - timeScale(parseTime(e.start))) + 30)
            .attr('height', 10)
            .attr('rx', 8)
            .attr('ry', 8)
            .style('fill', '#fff')
            .style('z-index', '-1')
            .style('stroke', '#f39696')
            .style('stroke-width', '3');
        }
        svg.append('line')
          .attr('x1', timeScale(parseTime(e.start)) + 40)
          .attr('x2', timeScale(parseTime(e.start)) + 40)
          .attr('y1', 108)
          .attr('y2', 180)
          .style('stroke', '#E22828')
          .style('stroke-width', '1');
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 130)
          .attr('font-size', 10)
          .attr('fill', '#aaa')
          .text(getDateRange(e.start, e.end));
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 138)
          .attr('font-size', 10)
          .attr('fill', '#ccc')
          .text(e.location);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 148)
          .attr('font-size', 12)
          .attr('fill', '#000')
          .text(e.line1);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 158)
          .attr('font-size', 12)
          .attr('fill', '#000')
          .text(e.line2);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 168)
          .attr('font-size', 12)
          .attr('fill', '#000')
          .text(e.line3);
        // Desktop End -- Even
        // Mobile Start -- Even
        if (!isRange(e.start, e.end)) {
          mobileSvg.append('circle')
            .attr('cy', mobileTimeScale(parseTime(e.start)) + 40)
            .attr('cx', mobileWidth / 2)
            .attr('r', 8)
            .style('fill', '#fff')
            .style('stroke', '#E22828')
            .style('stroke-width', '3');
        } else {
          mobileSvg.append('rect')
            .attr('y', mobileTimeScale(parseTime(e.start)) + 30)
            .attr('x', mobileWidth / 2 - 5)
            .attr('height', (mobileTimeScale(parseTime(e.end)) - mobileTimeScale(parseTime(e.start))) + 30)
            .attr('width', 10)
            .attr('rx', 8)
            .attr('ry', 8)
            .style('fill', '#fff')
            .style('z-index', '-1')
            .style('stroke', '#f39696')
            .style('stroke-width', '4');
        }
        mobileSvg.append('line')
          .attr('y1', mobileTimeScale(parseTime(e.start)) + 40)
          .attr('y2', mobileTimeScale(parseTime(e.start)) + 40)
          .attr('x1', mobileWidth / 2 + 7)
          .attr('x2', mobileWidth / 2 + 60)
          .style('stroke', '#E22828')
          .style('stroke-width', '1');
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 32)
          .attr('x', mobileWidth / 2 + 65)
          .attr('font-size', 8)
          .attr('fill', '#aaa')
          .text(getDateRange(e.start, e.end));
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 42)
          .attr('x', mobileWidth / 2 + 65)
          .attr('font-size', 8)
          .attr('fill', '#ccc')
          .text(e.location);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 52)
          .attr('x', mobileWidth / 2 + 65)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line1);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 62)
          .attr('x', mobileWidth / 2 + 65)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line2);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 72)
          .attr('x', mobileWidth / 2 + 65)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line3);
        // Mobile End -- Even
      } else {
        // Desktop Start -- Odd
        if (!isRange(e.start, e.end)) {
          svg.append('circle')
            .attr('cx', timeScale(parseTime(e.start)) + 40)
            .attr('cy', 100)
            .attr('r', 8)
            .style('fill', '#fff')
            .style('stroke', '#E22828')
            .style('stroke-width', '3');
        } else {
          svg.append('rect')
            .attr('x', timeScale(parseTime(e.start)) + 30)
            .attr('y', 100 - 3)
            .attr('width', (timeScale(parseTime(e.end)) - timeScale(parseTime(e.start))) + 30)
            .attr('height', 10)
            .attr('rx', 8)
            .attr('ry', 8)
            .style('fill', '#fff')
            .style('z-index', '-1')
            .style('stroke', '#f39696')
            .style('stroke-width', '3');
        }
        svg.append('line')
          .attr('x1', timeScale(parseTime(e.start)) + 40)
          .attr('x2', timeScale(parseTime(e.start)) + 40)
          .attr('y1', 20)
          .attr('y2', 92)
          .style('stroke', '#E22828')
          .style('stroke-width', '1');

        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 32)
          .attr('font-size', 8)
          .attr('fill', '#aaa')
          .text(getDateRange(e.start, e.end));
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 40)
          .attr('font-size', 8)
          .attr('fill', '#ccc')
          .text(e.location);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 50)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line1);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 60)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line2);
        svg.append('text')
          .attr('x', timeScale(parseTime(e.start)) + 45)
          .attr('y', 70)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line3);
        // Desktop End -- Odd
        // Mobile Start -- Odd
        if (!isRange(e.start, e.end)) {
          mobileSvg.append('circle')
            .attr('cy', mobileTimeScale(parseTime(e.start)) + 40)
            .attr('cx', mobileWidth / 2)
            .attr('r', 8)
            .style('fill', '#fff')
            .style('stroke', '#E22828')
            .style('stroke-width', '3');
        } else {
          mobileSvg.append('rect')
            .attr('y', mobileTimeScale(parseTime(e.start)) + 30)
            .attr('x', mobileWidth / 2 - 5)
            .attr('height', (mobileTimeScale(parseTime(e.end)) - mobileTimeScale(parseTime(e.start))) + 30)
            .attr('width', 10)
            .attr('rx', 8)
            .attr('ry', 8)
            .style('fill', '#fff')
            .style('z-index', '-1')
            .style('stroke', '#f39696')
            .style('stroke-width', '4');
        }
        mobileSvg.append('line')
          .attr('y1', mobileTimeScale(parseTime(e.start)) + 40)
          .attr('y2', mobileTimeScale(parseTime(e.start)) + 40)
          .attr('x1', mobileWidth / 2 - 60)
          .attr('x2', mobileWidth / 2 - 7)
          .style('stroke', '#E22828')
          .style('stroke-width', '1');

        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 32)
          .attr('x', mobileWidth / 2 - 130)
          .attr('font-size', 8)
          .attr('fill', '#aaa')
          .text(getDateRange(e.start, e.end));
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 42)
          .attr('x', mobileWidth / 2 - 130)
          .attr('font-size', 8)
          .attr('fill', '#ccc')
          .text(e.location);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 52)
          .attr('x', mobileWidth / 2 - 130)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line1);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 62)
          .attr('x', mobileWidth / 2 - 130)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line2);
        mobileSvg.append('text')
          .attr('y', mobileTimeScale(parseTime(e.start)) + 72)
          .attr('x', mobileWidth / 2 - 130)
          .attr('font-size', 10)
          .attr('fill', '#000')
          .text(e.line3);
        // Mobile End -- Odd
      }
    }
  }

});
